const $ = require('jquery');

const video = document.querySelector('.js-background-video')
	, container = document.querySelector('.js-background-video__container');

const setVideoDimensions = function () {

	const w = video.videoWidth
		, h = video.videoHeight;


	const videoRatio = (w / h).toFixed(2);

	const containerStyles = window.getComputedStyle(container)
		, minW = parseInt( containerStyles.getPropertyValue('width') )
		, minH = parseInt( containerStyles.getPropertyValue('height') );

	const widthRatio = minW / w
		, heightRatio = minH / h;

	if (widthRatio > heightRatio) {
		var newWidth = minW;
		var newHeight = Math.ceil( newWidth / videoRatio );
	}
	else {
		var newHeight = minH;
		var newWidth = Math.ceil( newHeight * videoRatio );
	}

	video.style.width = newWidth + 'px';
	video.style.height = newHeight + 'px';

};

const videoElement = $('.js-background-video__container').find('video');
let isPaused;

module.exports = {

	init: () => {

		if (videoElement.length > 0 && videoElement.get(0).autoplay === true) {
			videoElement.get(0).play();
		}


		if (video) {

			if (video.readyState === 0) {
				video.addEventListener('loadedmetadata', setVideoDimensions, false);
			} else if (video.readyState >= 1) {
				setVideoDimensions();
			}

			window.addEventListener('resize', setVideoDimensions, false);
			window.addEventListener('load', setVideoDimensions, false);

		}

		$('.js-actions-video').on('click', function(event) {
			event.preventDefault();
			if (videoElement.get(0).muted === true) {
				videoElement.prop('muted', false);
				$(this).removeClass('is-muted');
			}
			else {
				videoElement.prop('muted', true);
				$(this).addClass('is-muted');
			}

		});

		$('.js-load-and-play-video').on('click', function(event)
		{
			event.preventDefault();

			let nextVideoPath = $(this).attr('data-video-path');
			let nextVideoSrc = $(this).attr('data-video-src');

			let videoTag = document.getElementById('js-video-tag');

			let mp4 = document.getElementById('js-mp4-video-src');
			let ogv = document.getElementById('js-ogv-video-src');
			let webm = document.getElementById('js-webm-video-src');

			mp4.src = nextVideoPath + nextVideoSrc + '.mp4';
			ogv.src = nextVideoPath + nextVideoSrc + '.ogv';
			webm.src = nextVideoPath + nextVideoSrc + '.webm';

			$(this).fadeOut();

			videoTag.muted = false;
			videoTag.loop = false;
			videoTag.load();
			videoTag.play();

			console.debug(videoTag.muted);
			console.debug(videoTag);
		});

		$('.js-toggle-video').on('click', function(event)
		{
			event.preventDefault();

			if (isPaused === true)
			{
				videoElement.get(0).play();
				isPaused = false;
				$('.video-actions__button').hide();
				$('.video-actions__button--stop').show();
			}
			else
			{
				videoElement.get(0).pause();
				isPaused = true;
				$('.video-actions__button').hide();
				$('.video-actions__button--play').show();
			}

		});

	},
};

